import { Tabs } from "@components/shared/Tabs";
import * as React from "react";

export interface DeckSelectProps {
  /**
   * The currently selected deck number
   */
  value: number;
  /**
   * What to do when the user selects a deck
   */
  setValue: (value: number) => void;
}

/**
 * The deck selection component for the seat map.
 */
export const DeckSelect: React.FC<DeckSelectProps> = ({ value, setValue }) => {
  const options = ["Lower deck", "Upper deck"];
  return (
    <Tabs
      options={options}
      value={options[value]}
      onChange={(item) => setValue(options.indexOf(item))}
    />
  );
};
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";